/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.requests.controllers', [])

.controller('OrdersRequestsController', ['$scope', function($scope) {

    $scope.ordersRequests = {

      model: "Your spankin new application.orders.requests view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.ordersRequests.init();

}]);
